import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreRefreshService {
  private refreshStoresSubject = new Subject<void>();

  refreshStores$ = this.refreshStoresSubject.asObservable();

  triggerRefresh() {
    this.refreshStoresSubject.next();
  }
} 